import { useClientBookingContext } from "@/contexts/clientBookingContext";
import { BookingStep } from "@/types/bookingTypes";

export default function useBookingNavBar() {
  const {
    step,
    setStep,
    selectedServices,
    selectedProvider,
    hasMixedAppointmentTypes,
    timeSlot,
  } = useClientBookingContext();

  const continueActions: Partial<Record<BookingStep, () => void>> = {
    [BookingStep.SERVICES]: () =>
      setStep(BookingStep.AVAILABILITY_AND_PROVIDER_SELECTION),
    [BookingStep.AVAILABILITY_AND_PROVIDER_SELECTION]: () =>
      setStep(BookingStep.PHONE_NUMBER),
  };
  const goNext = continueActions[step];
  const onContinue = () => {
    goNext();
    window?.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const continueDisabledPerStep: Partial<Record<BookingStep, boolean>> = {
    [BookingStep.SERVICES]: selectedServices.length === 0,
    [BookingStep.AVAILABILITY_AND_PROVIDER_SELECTION]:
      !selectedProvider || !timeSlot,
  };
  const continueDisabled =
    continueDisabledPerStep[step] || hasMixedAppointmentTypes;

  const visible = [
    BookingStep.SERVICES,
    BookingStep.AVAILABILITY_AND_PROVIDER_SELECTION,
  ].includes(step);

  return {
    visible,
    onContinue,
    hasMixedAppointmentTypes,
    continueDisabled,
  };
}
